export const BASE_URL = "https://www.investwithcertainty.com";
// export const BASE_URL = "";
export const USERS_URL = "/api/users";
export const UPLOAD_URL = "/api/upload";
export const REPORT_URL = "/api/reports";
export const PAYMENT_URL = "/api/payments";
export const CONTACT_URL = "/api/contacts";
